import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import {
    Container,
    HeaderNavigation,
    Content,
    FooterNavigation,
    WhatsAppButton,
    WhatsAppIcon,
} from './styles'
import { Header } from './Header'
import { Footer } from './Footer/Footer'
import { CustomModal } from 'src/components/common/Modal/CustomModal'
import ChildrenModal from 'src/components/common/ChildrenModal'
import Congratulations from 'src/assets/logos/congratulations.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
import WhatsApp from 'src/assets/Icons/whatapp_18_11zon.avif'

interface Props {
    footer?: boolean
}
export function Main(props: Props) {
    const { footer = true } = props
    const t = useTranslations()
    const [completeSubscription, setCompleteSubscription] =
        useState<boolean>(false)
    const handleChangeCompleteSubscription = () => {
        setCompleteSubscription(!completeSubscription)
    }
    return (
        <Container width={1}>
            {completeSubscription && (
                <CustomModal
                    handleClose={handleChangeCompleteSubscription}
                    content={
                        <ChildrenModal
                            handleClose={handleChangeCompleteSubscription}
                            image={Congratulations}
                            title={t('subscription.modal.title')}
                            content={t('subscription.modal.content')}
                            double={true}
                            button={t('cta.letsGo')}
                        />
                    }
                />
            )}
            <HeaderNavigation width={1}>
                <Header />
            </HeaderNavigation>
            <Content>
                <Outlet />
                <WhatsAppButton
                    href="https://api.whatsapp.com/send?phone=573234142211"
                    target="_blank"
                    rel="noreferrer"
                >
                    <WhatsAppIcon src={WhatsApp} alt="WhatsApp" />
                </WhatsAppButton>
            </Content>
            {footer && (
                <FooterNavigation width={1} paddingTop={10}>
                    <Footer
                        setCompleteSubscription={
                            handleChangeCompleteSubscription
                        }
                    />
                </FooterNavigation>
            )}
        </Container>
    )
}
